// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e7fae0d3","637":"28d591c0","885":"c1e05168"}[chunkId] + ".chunk.js";
};